import React, { useEffect } from 'react';
import './InAppNotification.css';
import Logo from '../Assets/Images/Logo.png';

const NotificationItem = ({ notification, onClose, onClick }) => {
  useEffect(() => {
    if (!notification.duration || notification.duration <= 0) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      onClose(notification.id);
    }, notification.duration);

    return () => {
      window.clearTimeout(timer);
    };
  }, [notification.duration, notification.id, onClose]);

  return (
    <article
      className="in-app-notification__item"
      role="button"
      tabIndex={0}
      onClick={() => onClick(notification)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick(notification);
        }
      }}
      aria-label={`Abrir notificacion: ${notification.title}`}
    >
      <div className="in-app-notification__media">
        <img
          src={Logo}
          alt="Falla Plaza Rodrigo"
          className="in-app-notification__avatar"
        />
      </div>
      <div className="in-app-notification__content">
        <p className="in-app-notification__eyebrow">Falla Plaza Rodrigo</p>
        <h4 className="in-app-notification__title">{notification.title}</h4>
        <p className="in-app-notification__message">{notification.message}</p>
      </div>
      <button
        type="button"
        className="in-app-notification__close"
        onClick={(event) => {
          event.stopPropagation();
          onClose(notification.id);
        }}
        aria-label="Cerrar notificacion"
      >
        ×
      </button>
    </article>
  );
};

export const InAppNotification = ({ notifications, onClose, onClick }) => {
  if (!notifications.length) {
    return null;
  }

  return (
    <section
      className="in-app-notification"
      aria-live="polite"
      aria-atomic="false"
    >
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onClose={onClose}
          onClick={onClick}
        />
      ))}
    </section>
  );
};
